import { render, staticRenderFns } from "./DetailsFooter.vue?vue&type=template&id=33e119b9&"
import script from "./DetailsFooter.vue?vue&type=script&lang=js&"
export * from "./DetailsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports